export default {
    noticelog:{
        // 日志类型
        log_email:"Email Log",
        log_sms:"SMS Log",
        log_voice:"Voice Log",


        email:"Email",
        type:"Type",
        send_status:"Send Status",
        mail_content:"Email Content",
        sms_content:"SMS Content",
        send_time:"Send Time",
        result:"Return Result",
        voice_content:"Voice Content",
        // 邮件发送状态

        send_success:"Send Successful",
        send_fail:"Send Failed",

        //类型
        type_alarm:"Alarm",
        type_captcha:"Please input Verification Code.",
        
    }
}